import { render, staticRenderFns } from "./preferences.vue?vue&type=template&id=fb3cdb8e&scoped=true&"
import script from "./preferences.vue?vue&type=script&lang=js&"
export * from "./preferences.vue?vue&type=script&lang=js&"
import style0 from "./preferences.vue?vue&type=style&index=0&id=fb3cdb8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb3cdb8e",
  null
  
)

export default component.exports